import ListProducers from "@/views/organization/partners/query_producers/ListProducers.vue";
import ShowProducer from "@/views/organization/partners/query_producers/ShowProducer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "partners",
  permission: "query_producers"
});

export default [
  {
    path: "/org/:organization_id/partners/query_producers/list",
    name: routeName(""),
    redirect: { name: routeName("list_producers") }
  },
  {
    path: "/org/:organization_id/partners/query_producers/list",
    name: routeName("list_producers"),
    component: ListProducers,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/partners/query_producers/:producer_id/show",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  }
];
